<template>
    <div class="message-review">
        <div class="content-total">
            <div class="ct-item">
                <h3>提豆成功总金额：</h3>
                <span v-text="withdraw.successAmount"></span><span>元</span>
            </div>
            <div class="ct-item">
                <h3>审核中总金额：</h3>
                <span v-text="withdraw.checkingAmount"></span><span>元</span>
            </div>
        </div>
        <div class="bm-header">
            <div class="block">
                <el-button type="danger" @click="rejectDialog">拒绝</el-button>
                <el-button type="warning" @click="frozen">冻结</el-button>
                <el-button type="success" @click="approve">同意</el-button>
                <el-button type="success" @click="processed">转人工-已处理</el-button>   
            </div>
        </div>
        <div class="bm-search">
            <div class="block">
                <el-select v-model="status" class="cs-select" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="block">
                <el-date-picker
                    class="time"
                    v-model="time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    align="right">
                </el-date-picker>
            </div>
            <div class="block">
                <el-input
                        class="common-el-input"
                        placeholder="输入玩家昵称或ID查询"
                        v-model="searchVal">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>
            <div class="block">
                <el-button type="primary" @click="getApplyList(1)">搜索</el-button> 
            </div>
        </div>
        <div class="bm-table">
            <el-table :data="douList.beanList" height="100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="提豆号" prop="withdrawNo" align="center"/>
                <el-table-column label="玩家ID" prop="userRandomId" align="center"/>
                <el-table-column label="玩家昵称" align="center" prop="userNickname"/>
                <el-table-column label="所属俱乐部名称" align="center" prop="clubName"/>
                <el-table-column label="所属子联盟昵称" align="center" prop="subTribeName"/>
                <el-table-column label="所属主联盟昵称" align="center" prop="mainTribeName"/>
                <el-table-column label="交易模式" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.clubTransType == 0">
                            俱乐部充值
                        </div>
                        <div v-else-if="scope.row.clubTransType == 1">
                            平台充值
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="提豆数量" align="center" prop="chip">
                  <template slot-scope="scope">{{scope.row.chip | numberChip}}</template>
                </el-table-column>
                <el-table-column label="GAS费（元）" align="center">
                  <template slot-scope="scope">{{scope.row.gas | numberChip}}</template>
                </el-table-column>
                <el-table-column label="提豆费（元）" align="center">
                  <template slot-scope="scope">{{scope.row.chipFee | numberChip}}</template>
                </el-table-column>
                <el-table-column label="提豆金额（元）" align="center" prop="amount">
                </el-table-column>
                <el-table-column label="申请时间" align="center" prop="createdTime"/>
                <el-table-column label="账号信息" align="center" prop="accountInfo">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="primary" @click="checkInfo(scope.row.id)">查看</el-button> 
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="提豆状态" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 0">
                            审核中
                        </div>
                        <div v-else-if="scope.row.status == 1">
                            打款中
                        </div>
                        <div v-else-if="scope.row.status == 2">
                            提现成功
                        </div>
                        <div v-else-if="scope.row.status == 3">
                            提现失败
                        </div>
                        <div v-else-if="scope.row.status == 4">
                            
                            <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="left-start">
                                <el-button>已拒绝</el-button>
                            </el-tooltip>
                        </div>
                        <div v-else-if="scope.row.status == 5">
                          冻结中
                        </div>
                        <!-- <el-popover
                            ref="popoverReject"
                            placement="top-start"
                            title="拒绝原因:"
                            width="200"
                            trigger="hover"
                            :content="scope.row.remark">
                        </el-popover> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="douList.total"
                @current-change="getApplyList($event)"/>
        <!-- 查看账户信息 -->
        <el-dialog
            title="账户信息"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <div class="dialog-content">
                <el-form ref="form" :model="accountInfo" label-width="80px">
                    <el-form-item label="户名">
                        <el-input v-model="accountInfo.bankAccName"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡号">
                        <el-input v-model="accountInfo.bankAccNo"></el-input>
                    </el-form-item>
                    <el-form-item label="银行名称">
                        <el-input v-model="accountInfo.bankName"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行">
                        <el-input v-model="accountInfo.bankOfDeposit"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式">
                        <el-input v-model="accountInfo.contact"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 查看操作信息 -->
        <el-dialog
            title="处理结果"
            :visible.sync="resultDialogVisible"
            @close="closeResultDialog"
            width="80%"
            center>
            <div class="dialog-content">
                <el-table :data="resultList" height="100%">
                    <el-table-column label="提豆号" prop="withdrawNo" align="center"/>
                    <el-table-column label="玩家ID" prop="userRandomId" align="center"/>
                    <el-table-column label="玩家昵称" align="center" prop="userNickname"/>
                    <el-table-column label="所属俱乐部名称" align="center" prop="clubName"/>
                    <el-table-column label="提豆数量" align="center" prop="chip"/>
                    <el-table-column label="提豆金额(元)" align="center" prop="amount"/>
                    <el-table-column label="处理结果" align="center" prop="resultMsg"/>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeResultDialog">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'
    import { setTimeout } from 'timers';
    export default {
        inject:['reload'],
        data() {
            return {
                useSdk:true,
                // accountInfo:{},
                centerDialogVisible: false,
                time:'',
                date: null,
                searchVal: '',
                configIsShow: false,
                profitVal: '',
                tribeIdVal: '',
                configForm: {},
                currentPage:1,
                applyList:[],
                applyListTotal:0,
                status:'0',
                options:[
                    {
                        value: '',
                        label: '全部'
                    }, 
                    {
                        value: '0',
                        label: '审核中'
                    }, 
                    {
                        value: '1',
                        label: '打款中'
                    }, 
                    {
                        value: '2',
                        label: '提现成功'
                    }, 
                    {
                        value: '3',
                        label: '提现失败'
                    },
                    {
                        value: '4',
                        label: '已拒绝'
                    },
                    {
                      value: '5',
                      label: '已冻结'
                    }
                ],
                multipleSelection:[],
                resultDialogVisible:false,
                resultList:[]
            }
        },
        computed: {
            ...mapState('beanApi', ['douList','withdraw','accountInfo']),
        //    useSdkVal() {
        //         return this.useSdk;
        //     }
        },
        mounted(){
            this.getApplyList(1);
            // this.getUseSdk();
            // this.getApplyTotal();
        },
        created() {
            // this.searchClubList();
            // this.getAllUnionList();
        },
        watch: {
            // useSdkVal(newVal) {
            //     if (!newVal) return;
            //     this.useSdk = newVal
            // }
        },
        methods: {
            ...mapActions('beanApi', ['withdrawList','withdrawAgree','withdrawReject','withdrawAccountInfo','withdrawUseSdk','withdrawProcessed','withdrawTotal','withdrawFrozen']),
            closeResultDialog(){
                this.resultDialogVisible = false;
                this.reload();
            },
            rejectDialog() {
                var self = this;
                if(self.multipleSelection.length == 0){
                    self.$message("error", '请选择要操作的消息');
                    return;
                }
                this.$prompt('请输入拒绝理由', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValidator: self.filterRejectValue,
                inputErrorMessage: '不可超过30个汉字'
                }).then(({ value }) => {
                    if(self.multipleSelection.length == 0){
                        self.$message("error", '请选择要操作的消息');
                        return;
                    }else{
                        self.reject(value);
                    }
                })
            },
            filterRejectValue(value){
                if(value.length>60){
                    return '不可超过30个汉字'
                }else{
                    return true
                }

            },
            handleSelectionChange(val) {
                this.multipleSelection = new Array();
                for(var i=0;i<val.length;i++){
                    this.multipleSelection.push(val[i].id)
                }
            },
            //查看账户信息
            checkInfo(id){
                var data = {
                    withdrawChipId:id
                }
                var self = this;
                this.withdrawAccountInfo(data)
                    .then(res => {
                        self.centerDialogVisible = true;
                    })
            },
            //申请列表
            getApplyList(page){
                debugger
                this.getApplyTotal();
                var startTime = '';
                var endTime = '';
                if(this.time){
                    startTime=this.time[0];
                    endTime=this.time[1]||''
                }
                var data = {
                    status:this.status,
                    page:page,
                    size:20,
                    startTime:startTime,
                    endTime:endTime,
                    userIdOrNickname:this.searchVal
                }
                var self = this;
                this.withdrawList(data)
                    .then(res => {
                        // //提交数据到vuex
                        // if(res.code == 0){
                        //     debugger
                        //     self.applyList = new Array();
                        //     if(res.data){
                        //         self.applyList = res.data.beanList;
                        //         self.applyListTotal = res.data.total;
                        //     }
                        //     this.$message('success',res.msg);
                        // }else{
                        //     self.applyList = new Array();
                        //     this.$message('error',res.msg)
                        // }
                    })
            },
            //申请金豆总数
            getApplyTotal(){
                var self = this;
                var startTime = '';
                var endTime = '';
                if(this.time){
                    startTime=this.time[0];
                    endTime=this.time[1]||''
                }
                var data = {
                    startTime:startTime,
                    endTime:endTime,
                }
                this.withdrawTotal(data)
                    .then(res => {
                        // //提交数据到vuex
                        // if(res.code == 0){
                        //     debugger
                        //     if(res.data){
                        //         self.withdraw = {};
                        //         self.withdraw = res.data;
                        //     }
                        //     this.$message('success',res.msg);
                        // }else{
                        //     this.$message('error',res.msg)
                        // }
                    })
            },
            //同意申请
            approve(){
                debugger
                var self = this;
                if(self.multipleSelection.length == 0){
                    self.$message.error('请选择要操作的消息');
                    return;
                }
                var data = {withdrawChipIds:self.multipleSelection}
                this.withdrawAgree(data)
                    .then(res => {
                    //提交数据到vuex
                        debugger
                        if(res.code == 0){
                            if(self.multipleSelection.length>1){
                                self.resultList = new Array();
                                self.resultList = res.data;
                                self.resultDialogVisible = true;
                            }else{
                                self.$message.success('同意成功');
                                setTimeout(function(){
                                    self.reload()
                                },1000);
                            }  
                        }else{
                            self.$message.error(res.msg)
                        }
                    })
            },
            //冻结申请
            frozen(){
              var self = this;
              if(this.multipleSelection.length == 0){
                this.$message.error('请选择要操作的消息');
                return;
              }
              var data = {withdrawChipIds:this.multipleSelection}
              this.withdrawFrozen(data).then(res => {
                    //提交数据到vuex
                    if(res.code == 0){
                      if(self.multipleSelection.length>1){
                        self.resultList = new Array();
                        self.resultList = res.data;
                        self.resultDialogVisible = true;
                      }else{
                        self.$message.success('已冻结申请');
                        self.reload()
                      }
                    }else{
                      self.$message.error(res.msg)
                    }
                  })
            },
            //已处理申请
            processed(){
                debugger
                var self = this;
                if(self.multipleSelection.length == 0){
                    self.$message.error('请选择要操作的消息');
                    return;
                }
                var data = {withdrawChipIds:self.multipleSelection}
                this.withdrawProcessed(data)
                    .then(res => {
                    //提交数据到vuex
                        if(res.code == 0){
                            if(self.multipleSelection.length>1){
                                self.resultList = new Array();
                                self.resultList = res.data;
                                self.resultDialogVisible = true;
                            }else{
                                self.$message.success('操作成功');
                                setTimeout(function(){
                                    self.reload()
                                },1000);
                            }
                        }else{
                            self.$message.error(res.msg)
                        }
                    })
            },
            //拒绝申请
            reject(rejectValue){
                var self = this;
                if(this.multipleSelection.length == 0){
                    this.$message.error('请选择要操作的消息');
                    return;
                }
                var data = {withdrawChipIds:this.multipleSelection,remark:rejectValue}
                this.withdrawReject(data)
                    .then(res => {
                    //提交数据到vuex
                        if(res.code == 0){
                            if(self.multipleSelection.length>1){
                                self.resultList = new Array();
                                self.resultList = res.data;
                                self.resultDialogVisible = true;
                            }else{
                                self.$message.success('已拒绝申请');
                                self.reload()
                            }
                        }else{
                            self.$message.error(res.msg)
                        }
                    })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .message-review{
        // margin-top: 50px;
        .content-total{
            // padding: 30px 0;
            display: flex;
            align-items: center;
            .ct-item {
                width: 300px;
                text-align: left;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                font-size: 13px;
                margin-left: 30px;
                align-items: center;
            }
        }
        .bm-header{
            position: relative;
            display: flex;
            justify-content: flex-end;
            margin: 10px 20px;
            .bm-control{
                width: 200px;
                float: right;
            }
        }
        .bm-search{
            display:flex;
            justify-content: flex-end;
            margin: 10px 10px;
            .block{
                margin-right: 10px;
            }
            .common-el-input{
                width: 200px;
                // margin-right: 20px;
            }
        }  
    }
</style>
<style>
.el-table__body-wrapper{
    height: auto !important;
    overflow: auto;
}
</style>